import React from "react";

import paperPlanIcon from "../../../assets/images/paper-plane.png";

import ModalHolder from "../../molecules/ModalHolder";

import { H3, P } from "../../atoms/Texts";
import { PrimaryButton } from "../../atoms/Buttons";

const CreateSuccessModal = ({ title, message, backText, closeModal }) => {
  return (
    <ModalHolder closeModal={closeModal}>
      <div className="py-20">
        <img src={paperPlanIcon} alt="" className="h-24 w-24 mx-auto mb-10" />
        <H3 color="#22202D" fontFamily="medium" className="text-center">
          {title}
        </H3>
        <P color="#7D7B96" className="text-center md:w-3/4 mx-auto mt-2 mb-6">
          {message}
        </P>
        <div className="flex justify-center">
          <PrimaryButton.Light onClick={closeModal}>{backText}</PrimaryButton.Light>
        </div>
      </div>
    </ModalHolder>
  );
};

export default CreateSuccessModal;
